export default __webpack_public_path__ + "static/media/Github.42c61b01.svg";